import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { StatusMainPageInternalSubscriptionDialogComponent } from './subscription-dialog/internal-subscription-dialog/internal-subscription-dialog.component';
import { StatusMainPagePublicSubscriptionDialogComponent } from './subscription-dialog/public-subscription-dialog/public-subscription-dialog.component';
import { StatusPageSharedModule } from '../shared/status-page-shared.module';

/**
 * Shared module for status-main-page dialogs/components.
 * Keeps all common Material modules and shared feature dependencies in one place.
 */
@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    StatusPageSharedModule,
    StatusMainPagePublicSubscriptionDialogComponent,
    StatusMainPageInternalSubscriptionDialogComponent
  ],
})
export class StatusMainPageSharedModule {}
